import { __rest, __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgPercentCircleMid } from './svg/percent-circle-mid.svg.js';

/**
 * @deprecated - use PercentCircle.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
var PercentCircleMid = function (props) {
    var title = props.title; props.size; props.legacyBoundingBox; var rest = __rest(props, ["title", "size", "legacyBoundingBox"]);
    return (jsx(SvgPercentCircleMid, __assign({ viewBox: "-1.33 -1.33 26.66 26.66", "aria-label": title, role: "img" }, rest, { width: 24, height: 24, "data-pp-icon": "PercentCircleMid" })));
};

export { PercentCircleMid as default };
//# sourceMappingURL=PercentCircleMid.js.map
